import React from "react";
import "./ExaminationInfoCardAuditor.css";
import { Badge, Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import ExaminationStatus from "../../../helpers/ExaminationStatus";
import SecurityLevel from "../../../helpers/SecurityLevel";

class ExaminationInfoCardAuditor extends React.PureComponent {
  constructor(props) {
    super(props);

    this.securityLevelsLabels = new Map(
      SecurityLevel.getSecurityLevels().map((i) => [i.value, i.label]),
    );

    this.formatDate = this.formatDate.bind(this);
  }

  formatDate(dateString) {
    const d = new Date(Date.parse(dateString));
    return d
      ? ("0" + d.getDate()).slice(-2) +
          "." +
          ("0" + (d.getMonth() + 1)).slice(-2) +
          "." +
          d.getFullYear() +
          " " +
          ("0" + d.getHours()).slice(-2) +
          ":" +
          ("0" + d.getMinutes()).slice(-2)
      : "-";
  }

  render() {
    const { t } = this.props;

    const statusBar = ExaminationStatus.getStatusBar(
      this.props.examination ? this.props.examination?.status : 0,
    );

    let status;
    switch (this.props.examination?.status) {
      case 1:
      case 11:
      case 21:
      case 31:
      case 50:
      case 61:
        status = (
          <Badge className="btn-green">
            {t(
              ExaminationStatus.getTranslationByStatus(
                this.props.examination?.status,
              ),
            )}
          </Badge>
        );
        break;
      case 0:
      case 10:
      case 20:
      case 30:
      case 32:
      case 40:
      case 51:
      case 60:
        status = (
          <Badge className="btn-black">
            <FontAwesomeIcon icon={faCircleNotch} spin className="mr-1" />
            {t(
              ExaminationStatus.getTranslationByStatus(
                this.props.examination?.status,
              ),
            )}
          </Badge>
        );
        break;
      default:
        status = (
          <Badge className="btn-red">
            {t(
              ExaminationStatus.getTranslationByStatus(
                this.props.examination?.status,
              ),
            )}
          </Badge>
        );
        break;
    }

    const body = this.props.tReady ? (
      <>
        <Row className="mb-1">
          <Col>
            <div>
              <b className="mr-1">
                {t("SingleExamination.BasicInformation.Status")}:
              </b>
              {status}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.Class")}:</b>{" "}
              {this.props.examination?.className}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.Module")}:</b>{" "}
              {this.props.examination?.moduleName}
            </div>
          </Col>
          <Col style={{ borderLeft: "1px solid gray" }}>
            <div>
              <b>{t("SingleExamination.BasicInformation.InstancesCount")}:</b>{" "}
              {this.props.examination?.instances?.length}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.Start")}:</b>{" "}
              {this.formatDate(this.props.examination?.start)}{" "}
              {this.props.examination?.isAutoStart
                ? `(${t("SingleExamination.BasicInformation.AutoStart")})`
                : ""}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.End")}:</b>{" "}
              {this.formatDate(this.props.examination?.end)}{" "}
              {this.props.examination?.isAutoEnd
                ? `(${t("SingleExamination.BasicInformation.AutoEnd")})`
                : ""}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.SecurityLevel")}:</b>{" "}
              {t(
                this.securityLevelsLabels.get(
                  this.props.examination?.securityLevel,
                ),
              )}
            </div>
          </Col>
        </Row>
      </>
    ) : (
      <div>
        <Row className="pageTitle">
          <Col>
            <h2>
              {t("SingleExamination.Title")}:{" "}
              {this.props.examination ? this.props.examination?.name : ""}
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="centered pt-5 pb-5">
            <FontAwesomeIcon icon={faCircleNotch} spin />
          </Col>
        </Row>
      </div>
    );

    return <div>{body}</div>;
  }
}

export default ExaminationInfoCardAuditor;
